module.exports = __webpack_public_path__ + "static/media/phfsp.1b039db3.png";